import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import LandingPage from "@/pages/LandingPage";
import PropertyLanding from "@/pages/PropertyLanding";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Un solo dominio (leadradar.siacasaimmobiliare.it): le landing sono servite come percorsi.
//  - /presentazione            -> landing presentazione
//  - /propostaimmobiliare/:id  -> landing singolo immobile
//  - tutto il resto            -> app CRM
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/presentazione" element={<LandingPage />} />
          <Route path="/propostaimmobiliare" element={<PropertyLanding />} />
          <Route path="/propostaimmobiliare/:id" element={<PropertyLanding />} />
          <Route path="/immobile/:id" element={<PropertyLanding />} />
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
